import { AutoScaleDim, PageScaleView } from '../../models/autoScale'

const longestOn = (dims: AutoScaleDim[], axis: 'x' | 'y'): AutoScaleDim | null =>
    dims.reduce<AutoScaleDim | null>(
        (best, dim) => (dim.axis === axis && dim.inConsensus && (!best || dim.lengthPx > best.lengthPx) ? dim : best),
        null
    )

export const pickLongestAutoScaleDims = (view: PageScaleView): AutoScaleDim[] => {
    const regions = view.regions ?? []
    const groups = regions.length
        ? regions.map((region) => view.dims.filter((dim) => dim.regionId === region.regionId))
        : [view.dims]

    return groups
        .flatMap((dims) => [longestOn(dims, 'x'), longestOn(dims, 'y')])
        .filter((dim): dim is AutoScaleDim => dim !== null)
}
